import * as _4 from 'lodash4';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';
import { MetaRankingModalService } from './metaranking_modal_service';

interface ISurveyMetarankingModalModel {
  title: string;
  desc: string;
}

export class SurveyMetarankingModalController {
  private model: ISurveyMetarankingModalModel;

  constructor(
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration,
    private ngMetaRankingModalService: MetaRankingModalService
  ) {}

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  initialize() {
    const { title, desc } = _4.get(
      this.ngMetaRankingModalService.item,
      `custom.masterList[${this.ngMetaRankingModalService.currentIndex}]`,
      { title: '', desc: '' }
    );
    this.model = { title, desc };
  }

  hideModal() {
    this.ngMetaRankingModalService.isOpen = false;
  }
}

export class SurveyMetarankingModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/modals/metaranking_modal/survey_metaranking_modal.html';
  public controller: any = SurveyMetarankingModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/modals/metaranking_modal/survey_metaranking_modal.ts